import React, { useContext, useEffect } from "react";
import { getProductionLabels, initialProductionFilter } from "./FilterTypes/ProductionFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiProductionList from "components/Picker/ProductionPicker/MultiProductionList";

const ProductionFilter = () => {
  const title = site.currentEnvironment.tour.singular;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("production", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getProductionLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedProductions.length > 0,
    reset: () => initialProductionFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedProductions.map(p => p.productionId), b.selectedProductions.map(p => p.productionId))
  });
  useEffect(() => {
    setInitialValue("production", initialProductionFilter);
  }, []);

  const [selectedProductions, setSelectedProductions] = React.useState<server.dto.TourSmall[]>(initialProductionFilter.selectedProductions);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedProductions(getValue("production").selectedProductions);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("production", {
      selectedProductions
    });
    setPopupOpen(false);
  };

  if (!site.currentEnvironment.tour.enabled) {
    return <></>;
  }

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiProductionList
        value={selectedProductions}
        onChange={setSelectedProductions}
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default ProductionFilter;
